import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../Reveal";

const testimonials = [
  {
    quote:
      "Inden rejsen var jeg så bange for, at det ville blive svært at komme ind på hinanden, men gennem Stines teambuilding og på grund af det menneske hun er, blev det hurtigt let at snakke med en masse nye mennesker på en hel naturlig måde. Senere i hendes undervisning i \u201cSelvudvikling & Kommunikation\u201d, fik jeg en dybere forståelse for, hvorfor vi mennesker tænker og handler, som vi gør. Det gav mig mere ro i sindet og hjalp mig med at blive bevidst om, hvad der er vigtigt for mig, og hvor jeg kan ændre min adfærd for at føle mig gladere og tryggere i min hverdag.",
    name: "Miriam Shakoor",
    context: "Undervisning på rejsehøjskole i teambuilding, selvudvikling og kommunikation",
  },
  {
    quote:
      "I had the privilege of inviting Stine and Julie to lead the \u201cEmpower: Teachers Training Teachers\u201d workshop at Ensana Hotel and Spa in Budapest. Their work on voice as a powerful tool for teaching completely transformed our group. Through practical techniques on energy, volume control, self-confidence, and motivation, they showed us how to speak with presence, hold a room, and lead from authenticity. Stine and Julie created a safe, energizing space where every teacher left feeling clearer, louder, and more confident in their voice — both on and off the mat. For any teacher who wants to elevate their communication and impact, this workshop is essential. Thank you for bringing such power and heart to Budapest.",
    name: "Dev Kapil",
    title: "Founder, Progressive Hatha Yoga School",
    context: "Workshop for Yoga Teachers in Appearance, Empowerment and Grounding",
  },
  {
    quote:
      "Kæmpe anbefaling! Noget af det, jeg især værdsatte ved Stines tilgang, var, at hun gjorde noget, der for mig virkede uoverskueligt, helt konkret og enkelt, hvilket gjorde processen motiverende. For mig kom det især til at handle om mine tankemønstre og vaner. Stine hjalp mig med at se tanker og vaner som noget, jeg ikke bare behøver at reagere på, men som jeg selv kan forholde mig til og vælge, hvordan jeg vil handle på. Det har givet mig en helt anden bevidsthed om mine egne reaktioner og handlemuligheder. Det er nok den bedste anbefaling, jeg kan give: Det, jeg lærte hos Stine, er ikke bare noget, jeg brugte under forløbet, men noget jeg stadig aktivt bruger i mit arbejdsliv og min hverdag.",
    name: "Ida Ytterberg",
    context: "Individuelt coachingforløb",
  },
  {
    quote:
      "Mit forløb hos Stine har betydet rigtig meget for mig. Hun gav mig nogle enkle, men virkelig effektive værktøjer, som gjorde det nemmere at tage små skridt mod mine drømme, uden at det føltes uoverskueligt eller urealistisk. Jeg følte mig mødt, forstået og godt guidet hele vejen. Det var en rigtig god oplevelse, og jeg ville uden tvivl gøre det igen.",
    name: "William Milsted",
    context: "Individuelt coachingforløb",
  },
  {
    quote:
      "Stine er en fantastisk underviser. Hun giver så meget af sig selv og formår at gøre undervisningen både personlig og lærerig. Der er en rigtig god balance mellem oplæg, refleksion og øvelser, og hun er dygtig til at forklare og formidle stoffet. Jeg har fået så mange værktøjer med mig, som gør en stor forskel for mig.",
    name: "Kristine Vestergaard",
    context: "Undervisning på rejsehøjskole i teambuilding, selvudvikling og kommunikation",
  },
];

const panelClass = (i) =>
  `flex flex-col border-b border-black/[0.08] sm:border-r ${i % 2 === 1 ? "bg-[#F4F1EC]" : "bg-white"} ${
    i % 3 === 2 ? "lg:border-r-0" : ""
  }`;

const TestimonialPanel = ({ t, i }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={panelClass(i)} data-testid={`preview-testimonial-card-${i}`}>
      <div className="border-b border-black/[0.08] px-7 py-6">
        <p className="text-[19px] font-semibold leading-tight text-[#111827]">{t.name}</p>
        {t.title && <p className="mt-1 text-sm font-semibold leading-snug text-[#111827]">{t.title}</p>}
        <p className="mt-1 text-[13px] leading-snug text-[#111827]/55">{t.context}</p>
      </div>
      <div className="flex-1 p-7">
        <span className="font-display text-5xl leading-none text-[#852936]/35" aria-hidden="true">
          &ldquo;
        </span>
        <p
          className={`-mt-2 text-[15px] italic leading-relaxed text-[#111827]/75 ${
            expanded ? "" : "line-clamp-6 sm:line-clamp-none"
          }`}
        >
          {t.quote}
        </p>
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-3 text-[14px] font-semibold text-[#852936] transition-colors hover:text-[#6E1F2B] sm:hidden"
          data-testid={`preview-testimonial-toggle-${i}`}
        >
          {expanded ? "Vis mindre" : "Læs mere"}
        </button>
      </div>
    </div>
  );
};

const PreviewMennesket = () => (
  <section id="mennesket" className="relative overflow-hidden bg-[#F4F1EC] pt-16 sm:pt-24" data-testid="preview-section-mennesket">
    <div className="pointer-events-none absolute -right-40 top-10 h-[500px] w-[500px] rounded-full bg-[#A9B5A0]/20 blur-[140px]" />
    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <div className="mb-7 h-0.5 w-12 bg-[#852936]" />
        <h2
          className="font-display text-4xl font-semibold leading-[1.02] tracking-tight text-[#852936] sm:text-5xl md:text-6xl lg:text-7xl"
          data-testid="preview-heading-mennesket"
        >
          Referencer
        </h2>
      </Reveal>
    </div>

    <div className="relative mt-10 border-t border-black/[0.08] bg-white sm:mt-14" data-testid="preview-testimonials-list">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {testimonials.map((t, i) => (
          <TestimonialPanel key={t.name} t={t} i={i} />
        ))}

        {/* Plads til den sjette reference */}
        <Link
          to="/kontakt"
          className={`group ${panelClass(5)} min-h-[280px]`}
          data-testid="preview-testimonial-card-cta"
        >
          <div className="flex flex-1 flex-col justify-center p-7">
            <p className="font-display text-2xl font-semibold leading-snug text-[#852936]">
              Har vi arbejdet sammen?
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-[#111827]/70">
              Jeg bliver altid glad for at høre, hvad et forløb, en workshop eller undervisningen har betydet. Del gerne din oplevelse.
            </p>
            <span className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-[#852936] transition-colors group-hover:text-[#6E1F2B]">
              Skriv til mig <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
            </span>
          </div>
        </Link>
      </div>
    </div>
  </section>
);

export default PreviewMennesket;
